var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumeric24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4795 13.9951V8.04297C11.4339 8.07227 11.2223 8.16667 10.8447 8.32617C10.4704 8.48242 10.2588 8.56706 10.21 8.58008V7.60352C10.2881 7.56771 10.5355 7.44564 10.9521 7.2373C11.3688 7.02572 11.5983 6.90527 11.6406 6.87598H12.7148V13.9951H11.4795Z",
    fill: "#11302D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#11302D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72729 18.5455H15.8182",
    stroke: "#11302D",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumeric24);
export default __webpack_public_path__ + "static/media/numeric-24.7aabea0489272048ff71618eb305ffab.svg";
export { ForwardRef as ReactComponent };